import React, { Component } from 'react';
import graphql from 'babel-plugin-relay/macro';
import { QueryRenderer } from 'react-relay';
import { Redirect } from 'react-router-dom';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import AbEnvironment from '../auth/AbEnvironment';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import { Button, Grid, TextField } from '@mui/material';
import { TablePagination } from '@mui/material';
import GetApp from '@mui/icons-material/GetApp';
import VendorTransactionsList from './VendorTransactionsList';
import VendorTransactionsFetch from './VendorTransactionsFetch';
import LoadingSpinner from '../ui/LoadingSpinner';
import ServerError from '../ui/ServerError';
import SearchField from '../ui/SearchField';
import AppBindStyles from '../../AppBindStyles';

import { addDays, format, isValid, startOfDay, subMonths } from 'date-fns';

const abEnvironment = new AbEnvironment();
const VendorTransactionsQuery = graphql`
query VendorTransactionsQuery($startDate: Datetime, $endDate: Datetime, $accountName: String, $pAccountId: UUID, $vendorAccountId: UUID, $first: Int, $offset: Int) {
  getvendorresellerbindcardchargeswithsummary2(startTs: $startDate, endTs: $endDate, accountName: $accountName, pAccountId: $pAccountId, vendorAccountId: $vendorAccountId, first: $first, offset: $offset) {
    totalCount
    ...VendorTransactionsList_tl
  }
}
`;

const styleSheet = theme => ({
    root: {
      flexGrow: 1,
      //marginTop: 10,
    },
    flex: {
      flex: 1,
    },
    button: {
      marginLeft: theme.spacing(1),
      marginTop: '10px',
    },
    textField: {
      width: 160,
    }
});

class VendorTransactions extends Component {

  constructor(props) {
    super(props);


    let cToDate = new Date();
    let tDate = localStorage.getItem('vtToDate');
    if (tDate != null) {
      cToDate = new Date(tDate);
    }
    //search to date is "start of next day"
    let searchToDateUtc = startOfDay(addDays(cToDate, 1)).toISOString();

    let cFromDate = new Date();
    let fDate = localStorage.getItem('vtFromDate');
    if (fDate != null) {
      cFromDate = new Date(fDate);
    } else {
      cFromDate = subMonths(cToDate, 1);
    }
    //search from date is "start of day"
    let searchFromDateUtc = startOfDay(cFromDate).toISOString();

    this.state = {
      startDate: cFromDate,
      queryStartDateUtc: searchFromDateUtc,
      endDate: cToDate,
      queryEndDateUtc: searchToDateUtc,
      accountName: '', 
      page: 0,
      rowsPerPage: 10,
    };  
  }

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
      page: 0,
    });
  };

  setFromDate(theDate) {
    if (isValid(theDate)) {
      let searchDateUtc = startOfDay(new Date(theDate)).toISOString();
      localStorage.setItem('vtFromDate', theDate);
      this.setState({ startDate: theDate, queryStartDateUtc: searchDateUtc, page : 0 });
    }
  }

  setToDate(theDate) {
    if (isValid(theDate)) {
      let searchDateUtc = startOfDay(addDays(new Date(theDate), 1)).toISOString();
      localStorage.setItem('vtToDate', theDate);
      this.setState({ endDate: theDate, queryEndDateUtc: searchDateUtc, page : 0 });
    }
  }

  handleChangePage = (event, page) => {
    this.setState({page: page});
  }

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: event.target.value, page : 0});
  }

  // The download needs to do another query in case there is more data for
  // the range than is shown on the screen.
  downloadCsv(startDate, endDate, accountName, pAccountId, vendorAccountId, first, offset) {
    VendorTransactionsFetch.fetch(startDate, endDate, accountName, pAccountId, vendorAccountId, first, offset).toPromise()
    .then(vtf => {
      let theCount = vtf.getvendorresellerbindcardchargeswithsummary2.totalCount;
      if (theCount < 1) {
        return;
      }
      let thenodes = vtf.getvendorresellerbindcardchargeswithsummary2.nodes;

      let csv = 'Date, App, Customer, Charge, Rebate\n';
      thenodes.map(n=> {
        let tdate = format(new Date(n.transactionTime), 'yyyy-MM-dd');
        let bcc = Number(n.bindCardCharge)
                  .toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
        let rebate = Number(n.rebate)
                  .toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});


       let csvline = '' + tdate + ',' + n.appName + ','
                    + n.customerAccountName + ',' + bcc + ','
                    + rebate + '\n';
        csv = csv + csvline;
        return csvline;  //just to get around warning - does not do anything functionally
      });

 
      var hiddenElement = document.createElement('a');
      hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
      hiddenElement.target = '_blank';
      hiddenElement.download = 'transactions.csv';
      hiddenElement.click();
    })
    .catch(err => {
      // alert('Error: ' + err);
    });
  }

  render() {
    const { isAuthenticated, isAuthenticatedVendor, needAssent, logError } = this.props.auth;
    const classes = this.props.classes;

    if (!isAuthenticated() || needAssent() || !isAuthenticatedVendor()) { 
      return ( <Redirect to='/home' /> );
    }
    
    let theAccountNameSearch = '%';
    if (this.state.accountName !== '')
    {
      theAccountNameSearch = '%' + this.state.accountName + '%';
    }

    let vendorAccountId = abEnvironment.getUserAttribute('a_id');

    // Determine the offset
    let offset = 0;
    if (this.state.page > 0)
    {
      offset = this.state.page * this.state.rowsPerPage
    }
    let first = this.state.rowsPerPage;

    let totalCount = 0;

    /* TODO below you will notice the field says customer name but the state is passing in app name.  It should have been customer name
    to the query and the proc.  I did not change the signatures etc but when we make the change for rebates, we should fix then */
  
    return (
      <div className={classes.root}>
        <Grid container spacing={1} justifyContent="space-between">
          <Grid item>
            <Grid container spacing={2}>
              <Grid item>
                <SearchField
                    id="accountName"
                    label="Search by customer name"
                    value={this.state.accountName}
                    onChange={this.handleChange('accountName')}
                  />

              </Grid>
              <Grid item>
                <div style={AppBindStyles.datePickerField}>
                <DatePicker
                  style={AppBindStyles.datePickerField}
                  maxDateMessage={AppBindStyles.datePickerMessageMax}
                  autoOk
                  label="From date"
                  value={this.state.startDate}
                  onChange={(date) => this.setFromDate(date) }
                  format="YYYY-MM-DD"
                  disableFuture
                  renderInput={(params) => <TextField {...params} />}
                />
                </div>
              </Grid>
              <Grid item>
                <div style={AppBindStyles.datePickerField}>
                <DatePicker
                  style={AppBindStyles.datePickerField}
                  maxDateMessage={AppBindStyles.datePickerMessageMax}
                  autoOk
                  label="To date"
                  value={this.state.endDate}
                  onChange={(date) => this.setToDate(date) }
                  format="YYYY-MM-DD"
                  disableFuture
                  renderInput={(params) => <TextField {...params} />}
                />
                </div>
              </Grid>
              <Grid item>
                <Button
                  color="primary"
                  variant="contained"
                  className={classes.button}
                  onClick={() => 
                    this.downloadCsv(this.state.queryStartDateUtc, this.state.queryEndDateUtc, theAccountNameSearch,
                                    this.props.resellerAccountId, vendorAccountId,
                                    10000, 0)}
                >
                  Download Report&nbsp;&nbsp;<GetApp/>
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <QueryRenderer
          environment={abEnvironment.getEnvironment()}
          query={VendorTransactionsQuery}
          variables={{startDate: this.state.queryStartDateUtc,
                      endDate: this.state.queryEndDateUtc,
                      accountName: theAccountNameSearch,
                      pAccountId: this.props.resellerAccountId,
                      vendorAccountId: vendorAccountId,
                      first: first,
                      offset: offset}}
          render={({error, props})=> {
            if (error) {
              logError(error.message);
              return (
                <ServerError/>
              );
         } else if (props) {
              // Determine offset information
              totalCount = props.getvendorresellerbindcardchargeswithsummary2.totalCount;

              return (
                <div>
                  <VendorTransactionsList tl={props.getvendorresellerbindcardchargeswithsummary2} 
                                          history={this.props.history}
                                          resellerAccountId={this.props.resellerAccountId}/>
                  <div style={AppBindStyles.paginationTableFooter}>
                    <TablePagination
                      rowsPerPageOptions={[5, 10, 25]}
                      component="div"
                      count={totalCount}
                      rowsPerPage={this.state.rowsPerPage}
                      page={this.state.page}
                      backIconButtonProps={{
                        'aria-label': 'Previous Page',
                      }}
                      nextIconButtonProps={{
                        'aria-label': 'Next Page',
                      }}
                      onPageChange={this.handleChangePage}
                      onRowsPerPageChange={this.handleChangeRowsPerPage}
                    />                        
                  </div>
                </div>
              )
            }
            return (
              <LoadingSpinner />
            );
          }}
        />
      </div>
    );
  }
}
  
VendorTransactions.propTypes = {
  classes: PropTypes.object.isRequired,
};
  
export default withStyles(styleSheet)(VendorTransactions);
